var OCS = OCS || {};
OCS.Data = OCS.Data || {};
OCS.Data.Advisories = OCS.Data.Advisories || {};
OCS.Advisories = OCS.Advisories || {};
OCS.Advisories.Classes = OCS.Advisories.Classes || {};
OCS.Advisories.Functions = OCS.Advisories.Functions || {};
OCS.Advisories.Functions.define_AdvisoryData_class = function (in_implements) {
    var implements = [Options, Events, new Class(OCS.Interfaces.BaseData), new Class(OCS.Advisories.Interfaces.AdvActions), new Class(OCS.Advisories.Interfaces.AdvSig)];
    /* istanbul ignore if */
    if (in_implements && in_implements.length) {
        implements.combine(in_implements);
    }
    return new Class({
        Implements: implements,
        class_type: "Data",
        class_name: "AdvisoryData",
        data_type: 'AdvisoryData',
        options: {
            dataset: 'edu.ou.ocs.advisories',
            properties: {
                action: '',
                beginning_time: 0,
                ending_time: 0,
                etn: "0000",
                file: '',
                issued_time: 0,
                nwso: '',
                phenom: '',
                significance: '',
                draw_type: '',
                zone: []
            },
            key: ''
        },
        bound_methods: {},
        event_last_update: 0,
        adv_events: {},
        zone_objs: {},
        is_new: true,
        last_event: null,
        linked_id: null,
        is_old_timeout: null,
        is_old_timeout_time: 5000,
        full_record: false,
        geometry_manager: null,
        initialize: function (op) {
            if(!op) {
                op = {};
            }
            this.setOptions({properties: op});
            var key = this.get_key();
            if (OCS.Data.Advisories[key]) {
                // This key already exist, so lets add to it
                var existing_obj = OCS.Data.Advisories[key];
                existing_obj.setOptions({properties: op});
                if (!existing_obj.full_record && op && op.action !== "NEW" && op.action !== "UPG" && op.action !== "CAN") {
                    // Make sure we cover all the zones mentioned
                    existing_obj.new(parseInt(op.issued_time));
                }
                existing_obj.action(op);
                return existing_obj;
            }
            // We got to here meaning this is a new unseen event, setup our bound methods for use
            this.bound_methods.advisory_updated = this.advisory_updated.bind(this);
            this.bound_methods.advisory_cancelled = this.advisory_cancelled.bind(this);

            if (this.options.properties.action !== "NEW" && this.options.properties.action !== "UPG" && this.options.properties.action !== "CAN") {
                // This is not a full record
                this.new(parseInt(this.options.properties.issued_time));

            }
            this.action(op);

            OCS.Utilities = OCS.Functions.init_utilities();
            OCS.Data.Advisories[key] = this;
            this.is_old_timeout = setTimeout(this.set_as_old.bind(this), this.is_old_timeout_time);

        },

        /*
         * 
         * Event Fires
         * 
         */
        advisory_cancelled: function () {
            this.fireEvent('advisory_cancelled', this);
        },
        advisory_updated: function () {
            this.fireEvent('advisory_updated', this);
        },


        /*
         * Actions
         */
        action: function (op) {
            var time = parseInt(this.options.properties.issued_time);
            while (this.adv_events.hasOwnProperty(time)) {
                if (OCS.Utilities.is_object_equal(this.options.properties, this.adv_events[time].options)) {
                    // We have seen this before, bail out of here
                    return;
                }
                time = time + 1;
            }
            var act = this.options.properties.action.toLowerCase();
            var event_obj = new OCS.Advisories.Classes.AdvisoryDataEvent(op);

            this.adv_events[time] = event_obj;

            // Zone Processing
            if (this[act]) {
                this[act](time);
            }
            this.set_event_last_update(time);
            this.advisory_updated();
            this.last_event = event_obj;
            return event_obj;
        },
        new: function (time) {
            if (!this.options.properties.beginning_time && this.options.properties.issued_time) {
                // Without a given start time, assume it to be the issuance time.
                this.options.properties.beginning_time = this.options.properties.issued_time;
            }
            var i = 0;
            var zone = null;
            for (i; i < this.options.properties.zone.length; i++) {
                zone = this.get_zone(this.options.properties.zone[i], this.options.properties.beginning_time, this.options.properties.ending_time, this.options.properties.issued_time);
                if(zone) {
                    zone.event_action(this.options.properties);
                }

            }
            if (this.options.properties.action === "NEW") {
                this.full_record = true;
            }
        },
        upg: function (time) {
            this.can(time);
        },
        exa: function (time) {
            var i = 0;
            if (!this.options.properties.beginning_time && this.options.properties.issued_time) {
                // Without a given start time, assume it to be the issuance time.
                this.options.properties.beginning_time = this.options.properties.issued_time;
            }
            var zone = null;
            for (i; i < this.options.properties.zone.length; i++) {
                zone = this.get_zone(this.options.properties.zone[i], this.options.properties.beginning_time, this.options.properties.ending_time, this.options.properties.issued_time);
                zone.event_action(this.options.properties);
            }
        },
        exb: function (time) {
            var i = 0;
            if (!this.options.properties.beginning_time && this.options.properties.issued_time) {
                // Without a given start time, assume it to be the issuance time.
                this.options.properties.beginning_time = this.options.properties.issued_time;
            }
            var zone;
            for (i; i < this.options.properties.zone.length; i++) {
                zone = this.get_zone(this.options.properties.zone[i], this.options.properties.beginning_time, this.options.properties.ending_time, this.options.properties.issued_time);
                zone.event_action(this.options.properties);
            }
        },
        exp: function (time) {
            this.can(time);
        },
        ext: function (time) {
            var i = 0;
            var zone;
            for (i; i < this.options.properties.zone.length; i++) {
                zone = this.get_zone(this.options.properties.zone[i]);
                if (zone) {
                    zone.event_action(this.options.properties);

                }
            }
        },
//        cor: function (time) {
//            
//        },
        can: function (time) {
            var active_zones = [];
            if (this.options.properties.zone && this.options.properties.zone.length) {
                if (this.options.properties.zone.length) {
                    var i = 0;
                    var zone;
                    for (i; i < this.options.properties.zone.length; i++) {
                        zone = this.get_zone(this.options.properties.zone[i]);
                        if (zone) {
                            zone.event_action(this.options.properties);
                        }
                    }
                }
                active_zones = this.get_zone_ids(time + 1);
                if (!active_zones.length) {
                    this.set_ending_time(time + 60000);
                }
            }
            this.advisory_cancelled();
        },

        /*
         * 
         * Get / Set methods
         * 
         */
        get_advisory_class_name: function () {
            return this.adv_significance_strings[this.get_significance().toUpperCase()].toLowerCase();
        },

        get_adv_event_at_time: function (time) {
            var found_event = false;
            if (!time) {
                time = this.event_last_update;
            }
            var timestamp = OCS.Advisories.Functions.get_nearest_time(this.adv_events, time);
            if (timestamp) {
                if (this.adv_events.hasOwnProperty(timestamp)) {
                    return this.adv_events[timestamp];
                }
            }
            return found_event;
        },
        get_dataset: function () {
            return this.options.dataset;
        },
        get_dataset_obj: function () {
            return OCS.Functions.get_dataset_from_node(this.get_dataset());
        },
        get_etn: function () {
            return this.options.properties.etn;
        },
        set_event_last_update: function (event_time) {
            this.event_last_update = event_time;
        },
        get_geojson: function(time) {
            var feature_array = [];
            if(this.options.properties.draw_type === "lat_lon") {
                var prop = this.get_adv_event_at_time(time);
                if(prop) {
                    feature_array.push({"geometry": {}, "properties": OCS.Utilities.combine_objects(this.options.properties, prop.options), "type": "Feature"});
                }
            }
            if(this.options.properties.draw_type === "zone") {
                this.get_zone_ids(time).each(function(zone_id) {
                    feature_array.push(this.get_zone_feature(zone_id, time));
                }.bind(this));
            }
            return {"type": "FeatureCollection", "features": feature_array};
        },

        get_key: function () {
            if (!this.options.key || this.options.key === "") {
                var dateObj = OCS.Functions.get_OCSDateTime();
                this.options.key = OCS.Advisories.Functions.get_adv_key(this.get_wfo_id(), this.get_phenom(), this.get_significance(), this.get_etn(), dateObj.get_utc_string_with_format(this.get_issued_time(), dateObj.options.year_format));
            }
            return this.options.key;
        },
        get_wfo_id: function () {
            return this.options.properties.nwso;
        },
        get_phenom: function () {
            return this.options.properties.phenom;
        },
        get_significance: function () {
            return this.options.properties.significance;
        },
        get_issued_time: function (time) {
            if (time) {
                // We were given a specific time to look for
                var event = this.get_adv_event_at_time(time);
                if (event && event.options.issued_time) {
                    return event.options.issued_time;
                }
            }
            return this.options.properties.issued_time;
        },
        get_ending_time: function (time) {
            var zone_ending_time;
            if (Object.keys(this.zone_objs).length) {
                zone_ending_time = this.get_zone_ending_time(time);
                if(zone_ending_time) {
                    return zone_ending_time;
                }
            }
            var event = this.get_adv_event_at_time(time);
            if (event && !event.options.ending_time && time > 0) {
                return this.get_ending_time(OCS.Advisories.Functions.get_previous_event_timestamp(this.adv_events, time));
            }

            if (event && event.options.ending_time) {
                return event.options.ending_time;
            }
            return this.options.properties.ending_time;
        },
        set_ending_time: function(time) {
            this.options.properties.ending_time = time;
        },
        get_beginning_time: function () {
            return this.options.properties.beginning_time;
        },
        get_file: function (time) {
            var event = this.get_adv_event_at_time(time);
            if (event && !event.options.file && time > 0) {
                return this.get_file(OCS.Advisories.Functions.get_previous_event_timestamp(this.adv_events, time));
            }
            if (event && event.options.file) {
                return event.options.file;
            }

            return this.options.properties.file;
        },
        get_url: function (time) {
            return this.get_dataset_obj().get_url({}) + this.get_file(time);
        },
        get_action: function (time) {
            var event = this.get_adv_event_at_time(time);
            if(!event) {
                return false;
            }
            return event.options.action;
        },

        get_text: function (time) {
            var event_obj = this.get_adv_event_at_time(time);
            var event = event_obj.options;
            if (OCS.Utilities.is_undefined(event.text) || event.text === '') {
                if (OCS.Utilities.is_undefined(event.text)) {
                    event.text = '';
                }
                var ajax = OCS.Functions.get_ajax_manager();
                var url = this.get_url(time);
                var req = ajax.request(url, {'method': "get",
                    'url': url,
                    'cache': false,
                    "noCache": true,
                    "storeCompletedReq": 1,
                    'onSuccess': function (response) {
                        this.set_text(response.text, time);
                    }.bind(this)
                });
                /* istanbul ignore next */
                req.send();

            }
            return event.text;
        },
        set_text: function (txt, time) {
            if (txt) {
                var event_obj = this.get_adv_event_at_time(time);
                event_obj.set_text(txt);
            }
        },
        get_time_string: function () {
            var dateObj = OCS.Functions.get_OCSDateTime();
            return dateObj.get_display_time_string(this.get_ending_time());
        },
        get_adv_config: function () {
            return OCS.Advisories.Functions.get_adv_config(this.options.properties.phenom, this.options.properties.significance);
        },
        get_color: function () {
            return OCS.Advisories.Functions.get_adv_config_prop(this.options.properties.phenom, this.options.properties.significance, 'color');
        },
        get_name: function () {
            return OCS.Advisories.Functions.get_adv_config_prop(this.options.properties.phenom, this.options.properties.significance, 'name');
        },
        get_z_index: function () {
            return OCS.Advisories.Functions.get_adv_config_prop(this.options.properties.phenom, this.options.properties.significance, 'zindex');
        },
        get_zone: function (zone_id, beginning_time, ending_time, issued_time) {
            if (!this.zone_objs[zone_id] && beginning_time && ending_time) {
                this.zone_objs[zone_id] = new OCS.Advisories.Classes.AdvisoryDataZone({
                    zone_id: zone_id,
                    issued_time: issued_time,
                    beginning_time: beginning_time,
                    ending_time: ending_time,
                    dataset: this.options.dataset,
                    etn: this.options.properties.etn,
                    file: this.get_file(),
                    nwso: this.options.properties.nwso,
                    phenom: this.options.properties.phenom,
                    significance: this.options.properties.significance
                });
                this.zone_objs[zone_id].addEvent('advisory_geometry_update', this.bound_methods.advisory_updated);
            }
            return this.zone_objs[zone_id];
        },
        get_zone_ending_time: function(time) {
            var all_zones = Object.keys(this.zone_objs);
            var i = 0;
            var ending_time = this.options.properties.ending_time;
            var test_time = 0;
            for (i; i < all_zones.length; i++) {
                test_time = this.get_zone_property(all_zones[i], time, 'ending_time');
                if(test_time > ending_time) {
                    ending_time = test_time;
                }
            }
            return ending_time;
        },
        get_zone_ids: function (time) {
            if (!time) {
                time = this.event_last_update;
            }
            var all_zones = Object.values(this.zone_objs);
            var i = 0;
            var zone_ids = [];
            var zone;
            for (i; i < all_zones.length; i++) {
                zone = all_zones[i];
                if (time >= zone.options.issued_time && time <= zone.options.ending_time) {
                    zone_ids.push(zone.options.zone_id);
                }
            }
            return zone_ids;
        },
        get_zone_property: function(zone_id, time, property) {
            var zone = this.get_zone(zone_id);
            if (zone) {
                return zone.get_property_at_time(time, property);
            }
            return false;
        },
        get_zone_feature: function(zone_id, time) {
            var zone = this.get_zone(zone_id);
            if (zone) {
                return zone.get_feature(time);
            }
        },
        get_zone_properties: function(zone_id, time) {
            var zone = this.get_zone(zone_id);
            if (zone) {
                return zone.get_properties_at_time(time);
            }
            return false;
        },
        set_as_old: function () {
            this.is_new = false;
        },

        /*
         * 
         * Boolean Methods
         * 
         */
        is_active: function (timestamp) {
            var ending_time = this.get_ending_time(timestamp);
            if (ending_time && (this.options.properties.beginning_time || this.options.properties.issued_time)) {
                if ((timestamp >= this.options.properties.beginning_time || timestamp >= this.options.properties.issued_time) && timestamp <= ending_time) {
                    return true;
                }
            }
            return false;
        },
        is_expired: function (timestamp) {
            var ending_time = this.get_ending_time(timestamp);
            if (ending_time && this.options.properties.beginning_time) {
                if (timestamp > ending_time) {
                    return true;
                }
            }
            if (!ending_time && this.event_last_update) {
                // If the last update we saw was 2 months ago, expire it
                if (timestamp > (this.event_last_update + 2 * 31 * 24 * 60 * 60 * 1000)) {
                    return true;
                }
            }
            return false;
        },
        is_contained: function (start, end, strict) {
            var adv_start = this.get_beginning_time();
            var adv_issue = this.get_issued_time();
            var adv_end = this.get_ending_time();
            if (start && end && adv_start && adv_end) {
                if (start > adv_end) {
                    return false;
                }
                // If we are in strict mode, advisory has be contained, if not include from issuance time
                if ((end < adv_start && strict) || (end < adv_issue)) {
                    return false;
                }
                return true;
            }
            /* istanbul ignore next */
            if (start && end && !adv_start && adv_end && start < adv_end) {
                // For advisories with no start time
                return true;
            }
            /* istanbul ignore next */
            return false;
        },

        /*
         * 
         * Destroy Method
         * 
         */
        destroy: function () {
            if(this.is_old_timeout) {
                clearTimeout(this.is_old_timeout);
            }
            this.fireEvent('advisory_destroyed', this);
            var all_zones = Object.values(this.zone_objs);
            var i = 0;
            for (i; i < all_zones.length; i++) {
                all_zones[i].destroy();
            }

            this.advisory_text_popup = null;
            this.removeEvents();
            var key = this.get_key();
            OCS.Data.Advisories[key] = null;
            delete OCS.Data.Advisories[key];
            this.options = {};
            this.adv_events = {};
            this.zone_objs = {};
        }
    });
};
OCS.Advisories.Classes.AdvisoryData = OCS.Advisories.Functions.define_AdvisoryData_class();
/* istanbul ignore next */
try {
    if (typeof (module) !== 'undefined') {
        module.exports = {
            "init": OCS.Advisories.Functions.define_AdvisoryData_class,
            "Advisories": OCS.Data.Advisories
        };
    }
} catch (e) {

}